import cx from "classnames";
import { ComponentProps, FC, SVGProps } from "react";

import { Icon } from "atoms/icon/Icon";
import OfferIcon from "atoms/icon/icons/ic_offers_ol.svg";
import Info from "atoms/icon/icons/info.svg";

type InfoBoxType = "warning" | "info" | "success" | "error" | "discount" | "brand";

interface InfoBoxProps {
  type?: InfoBoxType;
  leftIcon?: FC<SVGProps<SVGSVGElement>>;
  text?: string;
  customColor?: string;
}

export const InfoBox = ({
  type = "info",
  leftIcon: Svg = Info,
  text,
  customColor,
}: InfoBoxProps) => {
  const colors = {
    info: "bg-light-grey text-black/80",
    error: "bg-red/10 text-red",
    discount: `bg-${customColor ?? "brand-color"} text-white`,
    success: "bg-green/10 text-green",
    warning: "bg-yellow/10 text-yellow",
    brand: "bg-brand-tint text-primary",
  };

  const iconColors: Record<InfoBoxType, ComponentProps<typeof Icon>["color"]> = {
    info: "currentColor",
    error: "currentColor",
    success: "currentColor",
    warning: "currentColor",
    discount: "white",
    brand: "brandColor",
  };

  return (
    <div
      style={{ backgroundColor: customColor || undefined }}
      className={cx(
        "flex items-center gap-x-2 text-body2",
        type === "info" ? "-mx-4 p-2 pl-4" : "rounded-lg p-3 pr-4",
        colors[type],
      )}
    >
      {Svg && (
        <div className="flex items-center">
          <Icon
            svg={type === "discount" ? OfferIcon : Svg}
            color={iconColors[type]}
            size="xsmall"
          />
        </div>
      )}
      <span className="text-body2">{text}</span>
    </div>
  );
};
